import { useEffect, useState } from 'react'

/**
 * Whether the viewport is below Tailwind's `md` breakpoint (768px), for the
 * few components whose phone layout is a different component, not just
 * different classes (for example a hover card that becomes a bottom sheet).
 *
 * Guarded like `useIsWideViewport`: when `matchMedia` is missing (the vitest
 * setup stubs none) it reports a wide viewport, so desktop stays the default.
 */
const NARROW_VIEWPORT_QUERY = '(max-width: 767.98px)'

function readIsNarrowViewport(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false
  }
  return window.matchMedia(NARROW_VIEWPORT_QUERY).matches
}

export function useIsNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(readIsNarrowViewport)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return
    }
    const mediaQuery = window.matchMedia(NARROW_VIEWPORT_QUERY)
    setIsNarrow(mediaQuery.matches)
    const onChange = () => setIsNarrow(mediaQuery.matches)
    mediaQuery.addEventListener?.('change', onChange)
    return () => mediaQuery.removeEventListener?.('change', onChange)
  }, [])

  return isNarrow
}
